<template>
  <div class="list-container">
  <div class="location-list-item">
    <img v-if="thumbnail" :src="thumbnail" class="location-list-item__thumbnail">
    <div class="location-list-item__body">
      <div class="location-list-item__section">
        <div class="location-list-item__reference">{{reference}}</div>
        <div class="location-list-item__address">{{address}}</div>
        <div class="location-list-item__submitted_count" v-if="submittedCount">Times submitted: {{submittedCount}}</div>
      </div>
      <div class="location-list-item__section">
        <div class="location-list-item__postcode">{{postcode}}</div>
        <div class="location-list-item__county">{{county}}</div>
      </div>

      <div class="location-list-item__section">
        <div v-if="submittedAt" class="location-list-item__date">Submitted: {{submittedAt}}</div>
        <div class="location-list-item__photo-count">{{imageCount}} photo(s)</div>
      </div>


      <div class="location-list-item__section actions">
        <el-button size="mini" icon="el-icon-edit" @click="$emit('edit')">Edit</el-button>
        <el-button size="mini" icon="el-icon-refresh-left" @click="$emit('reactivate')">Reactivate</el-button>
        <el-button size="mini" type="danger" plain icon="el-icon-delete" @click="$emit('delete')">Delete</el-button>
      </div>
    </div>
    <div class="location-list-item__actions">

    </div>

  </div>
            <div class="location-list-item__badges">
              <badge :active="badges.priorityBadge" @click="toggleBadge('priority')" color="primary">Priority</badge>
              <badge :active="badges.acceptBadge" @click="toggleBadge('accept')" color="green">Accept</badge>
              <badge :active="badges.rejectBadge" @click="toggleBadge('reject')" color="red">Reject</badge>
              <badge :active="badges.morePhotosBadge" @click="toggleBadge('morePhotos')" color="blue">More photos</badge>
            </div>
  </div>
</template>

<script>
  import Badge from "./badge";

  export default {
    name: "location-list-item",
    components: {Badge},
    props: {
      locationId: {
        type: String,
        required: true
      },
      badges: {
        type: Object
      },
      thumbnail: {
        type: String
      },
      reference: {
        type: String,
        required: true
      },
      address: {
        type: String,
        required: true
      },
      postcode: {
        type: String,
        required: true
      },
      county: {
        type: String,
        required: true
      },
      imageCount: {
        type: Number,
        required: true
      },
      submittedAt: {
        type: String
      },
      submittedCount: {
        type: Number | String
      }
    },
    methods: {
      async toggleBadge(badgeName) {
        let updatedObject = {};
        if(this.badges[badgeName + 'Badge']) {
          updatedObject[badgeName + 'Badge'] = false;
        } else {
          updatedObject[badgeName + 'Badge'] = true;
        }

        await this.axios.patch(`${process.env.VUE_APP_ROOT_API}/api/locations/${this.locationId}`,
          updatedObject,
          {
            headers: {
              Authorization: localStorage.getItem('Authorization')
            }
          });
        this.$emit('badgeChange', updatedObject);
      }
    }
  }
</script>

<style scoped>
  .list-container {
    padding-bottom: 1rem;
    border-bottom: 1px solid #e7e7e7;
  }

  .location-list-item {
    display: flex;
    align-items: center;
    height: 10rem;
    width: 100%;

  }

  .location-list-item__thumbnail {
    width: 10rem;
    height: 8rem;
    object-fit: cover;
    object-position: center;
    border-radius: 1rem;
  }

  .location-list-item__body {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: calc(100% - 10rem);
    height: 100%;
    padding-left: 1rem;
  }

  .location-list-item__reference {
    color: #32CC99;
    font-size: 1.2rem;
  }

  .location-list-item__section {
    width: 15rem;
  }

  .location-list-item__section div {
    margin: 1rem 0;
    font-size: 0.9rem;
  }

  .location-list-item__address {
    font-size: 1.1rem !important;
  }

  .location-list-item__submitted_count {
    font-size: 1rem;
  }

  .location-list-item__section.actions {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    width: 7.5rem;
  }

  .location-list-item__section.actions .el-button {
    margin-left: 0;
  }

  .location-list-item__badges {
    margin: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/location-list-item.vue